import React, { useState, useRef, useEffect } from "react";
import TopNavbar from '../../../../components/TopNavbar';
import SideNavbar from '../../../../components/SideNavbar';
import { useNavigate } from "react-router-dom";
import { useAppSelector } from '../../../../redux/store';

// Firebase
import { functions } from '../../../../firebaseConfig'; // Adjust the path based on your project structure
import { httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { db } from '../../../../firebaseConfig';
import { fetchCustomers } from '../Function/AccountFunctions'
import Toast from "../../../../components/Toast";

const AccountNewInvoice = () => {
    const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);
    const [activeSection, setActiveSection] = useState("Invoices");
    const [activeSections, setActiveSections] = useState("New Invoice");
    const navigate = useNavigate();
    const [customerName, setCustomerName] = useState({ name: "", id: "" });
    const [isCustomerDropdownOpen, setIsCustomerDropdownOpen] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState("SCRD-2024-0019");
    const [isInvoiceDropdownOpen, setIsInvoiceDropdownOpen] = useState(false);
    const [terms, setTerms] = useState("Due On Receipt");
    const [isTermsDropdownOpen, setIsTermsDropdownOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");
    const [selectedTax, setSelectedTax] = useState("");
    const [isItemDropdownOpen, setIsItemDropdownOpen] = useState(false);
    const [isTaxDropdownOpen, setIsTaxDropdownOpen] = useState(false);
    const [selectedTaxType, setSelectedTaxType] = useState('TDS');
    const [selectedTdsOption, setSelectedTdsOption] = useState('');
    const [isTdsDropdownOpen, setIsTdsDropdownOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [isErrorToast, setIsErrorToast] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);

    const customerRef = useRef<HTMLDivElement>(null);
    const invoiceRef = useRef<HTMLDivElement>(null);
    const termsRef = useRef<HTMLDivElement>(null);
    const itemRef = useRef<HTMLDivElement>(null);
    const taxRef = useRef<HTMLDivElement>(null);
    const tdsRef = useRef<HTMLDivElement>(null);

    const itemOptions = ["Item 1", "Item 2", "Item 3", "Item 4"];
    const taxOptions = ["No Tax (0%)", "GST (10%)", "VAT (20%)", "Sales Tax (8.5%)"];
    const sections = ["Invoices", "Payouts", "Invoice List"];
    const buttons = ["New Customer", "New Invoice"];
    const tdsOptions = ['Option 1', 'Option 2', 'Option 3'];
    // const customerOptions = ["John Doe", "Jane Smith", "Acme Corp", "Tech Solutions"];
    const invoiceOptions = ["SCRD-2024-0019", "SCRD-2024-0020", "SCRD-2024-0021"];
    const termsOptions = ["Due On Receipt", "Net 15", "Net 30", "Net 45", "Net 60"];

    const [loading, setLoading] = useState(false);
    const [customerOptions, setCustomerOptions] = useState<any[]>([]);

    const [orderNumber, setOrderNumber] = useState("");
    const [invoiceDate, setInvoiceDate] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [subject, setSubject] = useState("");
    const [table, setTable] = useState([
        {
            itemDetails: "",
            quantity: 0,
            rate: 0,
            tax: "",
            amount: 0, // Includes tax
        },
    ]);
    const [customerNotes, setCustomerNotes] = useState("");
    const [activeDropdown, setActiveDropdown] = useState<{ rowIndex: number | null, type: string | null }>({
        rowIndex: null,
        type: null
    });
    function calculateAmount(quantity: number, rate: number, taxPercentage: string): number {
        if (quantity <= 0 || rate <= 0) {
            return 0; // Return 0 for invalid quantity or rate
        }

        // Extract numeric value from the tax percentage string
        const numericTax = parseFloat(taxPercentage.replace(/[^0-9.]/g, ""));


        if (isNaN(numericTax) || numericTax < 0) {
            return 0; // Return 0 for invalid tax
        }

        const baseAmount = quantity * rate; // Calculate base amount
        const taxAmount = baseAmount * (numericTax / 100); // Calculate tax
        const totalAmount = baseAmount + taxAmount; // Add tax to base amount

        return parseFloat(totalAmount.toFixed(2)); // Return total amount rounded to 2 decimal places
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (customerRef.current && !customerRef.current.contains(event.target as Node)) {
                setIsCustomerDropdownOpen(false);
            }
            if (invoiceRef.current && !invoiceRef.current.contains(event.target as Node)) {
                setIsInvoiceDropdownOpen(false);
            }
            if (termsRef.current && !termsRef.current.contains(event.target as Node)) {
                setIsTermsDropdownOpen(false);
            }
            if (itemRef.current && !itemRef.current.contains(event.target as Node)) {
                setIsItemDropdownOpen(false);
            }
            if (taxRef.current && !taxRef.current.contains(event.target as Node)) {
                setIsTaxDropdownOpen(false);
            }
            if (tdsRef.current && !tdsRef.current.contains(event.target as Node)) {
                setIsTdsDropdownOpen(false);
            }
            if (!(event.target as Element).closest('.dropdown-container')) {
                setActiveDropdown({ rowIndex: null, type: null });
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleItemDropdownToggle = () => {
        setIsItemDropdownOpen(prev => !prev);
    };

    const handleTaxDropdownToggle = () => {
        setIsTaxDropdownOpen(prev => !prev);
    };

    const handleSelectItem = (value: string) => {
        setSelectedItem(value);
        setIsItemDropdownOpen(false);
    };

    const handleSelectTax = (value: string) => {
        setSelectedTax(value);
        setIsTaxDropdownOpen(false);
    };
    const handleCustomerDropdownToggle = () => {
        setIsCustomerDropdownOpen(prev => !prev);
    };

    const handleInvoiceDropdownToggle = () => {
        setIsInvoiceDropdownOpen(prev => !prev);
    };

    const handleTermsDropdownToggle = () => {
        setIsTermsDropdownOpen(prev => !prev);
    };

    const handleSelectCustomer = (value: { id: string, name: string }) => {
        setCustomerName(value);
        setIsCustomerDropdownOpen(false);
    };

    const handleSelectInvoice = (value: string) => {
        setInvoiceNumber(value);
        setIsInvoiceDropdownOpen(false);
    };

    const handleSelectTerms = (value: string) => {
        setTerms(value);
        setIsTermsDropdownOpen(false);
    };
    const handleTdsDropdownToggle = () => {
        setIsTdsDropdownOpen(prev => !prev);
    };

    const handleSelectTds = (value: string) => {
        setSelectedTdsOption(value);
        setIsTdsDropdownOpen(false);
    };

    const handleButtonClick = (button: string) => {
        setActiveSections(button);
        switch (button) {
            case "New Customer":
                navigate("/accounts");
                break;
            case "New Invoice":
                navigate("/accounts/invoice");
                break;
            default:
                break;
        }
    };

    const handleSectionClick = (section: string) => {
        setActiveSection(section);
        switch (section) {
            case 'Invoices':
                navigate('/accounts');
                break;
            case 'Payouts':
                navigate('/accounts/payouts');
                break;
            case 'Invoice List':
                navigate('/accounts/invoicelist');
                break;
            default:
                break;
        }
    };
    const getInputContainerClass = (numColumns: number) => {
        switch (numColumns) {
            case 1:
                return "w-[30%]";
            case 2:
                return "grid grid-cols-2 gap-6 w-[70%]";
            case 3:
                return "grid grid-cols-3 gap-6 w-[90%]";
            default:
                return "w-3/4";
        }
    };
    const inputClass = "w-full py-3 px-4 bg-white border-0 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600  transition duration-200";
    const gradientBorderStyles = {
        background: 'linear-gradient(white, white) padding-box, linear-gradient(180deg, #3483BE 0%, #02385E 100%) border-box',
        border: '1px solid transparent',
        borderRadius: '24px'
    };
    const labelClass = "block font-montserrat font-normal text-base text-black mb-2";

    async function loadCustomers(isLoadingMore = false) {
        // if (loading) return;

        // setLoading(true);
        try {
            const auth = getAuth();
            const result = await fetchCustomers(db, auth.currentUser);
            setCustomerOptions(result);

        } catch (error) {
            console.error('Failed to fetch invoices:', error);
        } finally {
            // setLoading(false);
        }
    }

    // Initial load
    useEffect(() => {
        loadCustomers()
    }, []);
 const handleSave = async () => {
        if (isGenerating) return;

        setIsGenerating(true);
        try {

            // Update the amount for each row in the table
            const updatedTable = table.map(row => ({
                ...row,
                amount: calculateAmount(row.quantity, row.rate, row.tax),
            }));

            const addCustomer = httpsCallable(functions, 'invoiceGeneration');


            const result = await addCustomer({
                customer: customerName?.id, // Replace with an actual UID for testing
                invoiceNumber: invoiceNumber,
                orderNumber: orderNumber,
                invoiceDate: invoiceDate,
                terms: terms,
                dueDate: dueDate,
                subject: subject,
                table: updatedTable,
                customerNotes: customerNotes,
            });
            setToastMessage("Invoice generated successfully!");
            setIsErrorToast(false);
            setShowToast(true);
            console.log(result.data);
        } catch (error) {
            setToastMessage("Failed to generate invoice. Please try again.");
            setIsErrorToast(true);
            setShowToast(true);
            console.error('Error adding customer:', error);
        }
    };
    const handleAddNewRow = () => {
        setTable((prev) => [...prev, {
            itemDetails: "",
            quantity: 0,
            rate: 0,
            tax: "",
            amount: 0,
        }]);

        // Show success toast
        setToastMessage("New row added successfully!");
        setIsErrorToast(false);
        setShowToast(true);
    };

    // Modify the delete row method
    const handleDeleteRow = (index: number) => {
        if (table.length > 1) {
            setTable((prev) => prev.filter((_, i) => i !== index));

            // Show success toast
            setToastMessage("Row deleted successfully!");
            setIsErrorToast(false);
            setShowToast(true);
        } else {
            // Show error toast if trying to delete the last row
            setToastMessage("Cannot delete the last row!");
            setIsErrorToast(true);
            setShowToast(true);
        }
    };

    return (
        <div className="min-h-screen bg-gray-200">
            {/* <div className="fixed top-0 left-0 w-full z-20">
                <TopNavbar />
            </div> */}
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>
            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
                <div className="bg-white p-6 rounded-3xl shadow-md w-full min-h-screen flex flex-col">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                            <div
                                className="flex items-center justify-center w-12 h-12 rounded-full"
                                style={{ background: "linear-gradient(180deg, #00A6D9 10%, #3483BE 100%)" }}  >
                                <img src={`${process.env.PUBLIC_URL}/images/desktop/basil_invoice-outline.svg`}
                                    alt="Icon" className="w-7 h-7" />
                            </div>
                            {sections.map((section) => (
                                <h2
                                    key={section}
                                    onClick={() => handleSectionClick(section)}
                                    className={`font-montserrat text-lg font-medium cursor-pointer ${activeSection === section ? "text-gray-900" : "text-stone-300"
                                        }`}
                                    style={{
                                        borderBottom: activeSection === section ? "2px solid transparent" : "none",
                                        backgroundImage: activeSection === section
                                            ? "linear-gradient(180deg, #00A6D9 0%, #3483BE 100%)"
                                            : "none",
                                        backgroundPosition: "bottom",
                                        backgroundSize: "100% 2px",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                >
                                    {section}
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className="px-6">
                        <div className="flex space-x-2 mt-6">
                            {buttons.map((button) => (
                                <button key={button} onClick={() => handleButtonClick(button)}
                                    className={`py-2 px-4 rounded-3xl text-center flex-shrink-0 ${activeSections === button
                                        ? 'bg-sky-950 font-montserrat font-normal text-[16px] text-white' : 'bg-gray-100 text-gray-900'}`}>
                                    {button}
                                </button>
                            ))}
                        </div>
                        <div className="mt-6">
                            <h3 className="font-montserrat-medium text-2xl font-gray-900 mb-4">
                                New Invoice
                            </h3>
                            <div className="mb-6">
                                <div className="w-[42%]">
                                    <div>
                                        <label htmlFor="customerName" className={labelClass}>Customer Name</label>
                                        <div className="relative" ref={customerRef}>
                                            <div>
                                                <input
                                                    type="text"
                                                    value={customerName.name}
                                                    onClick={handleCustomerDropdownToggle}
                                                    readOnly
                                                    className={`${inputClass} cursor-pointer pr-24`}
                                                    style={gradientBorderStyles}
                                                    placeholder="Select or add a customer"
                                                />
                                            </div>
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
                                                <button
                                                    type="button"
                                                    className="mr-2"
                                                    onClick={handleCustomerDropdownToggle}
                                                >
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                        alt="Dropdown Arrow"
                                                        className={`w-7 h-7 transition-transform ${isCustomerDropdownOpen ? 'rotate-180' : ''}`}
                                                    />
                                                </button>
                                                <div className="bg-indigo-300 w-[80px] rounded-3xl p-1">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/images/desktop/mynaui_search.svg`}
                                                        alt="search-icon"
                                                        className="w-7 h-7"
                                                    />
                                                </div>
                                            </div>
                                            {isCustomerDropdownOpen && (
                                                <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                                                    {customerOptions.map((option) => (
                                                        <div
                                                            key={option.id}
                                                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                            onClick={() => handleSelectCustomer(option)}
                                                        >
                                                            {option.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-6">
                                <div className={getInputContainerClass(2)}>
                                    <div>
                                        <label htmlFor="invoiceNumber" className={labelClass}>Invoice Number</label>
                                        <div className="relative" ref={invoiceRef}>
                                            <div>
                                                <input
                                                    type="text"
                                                    value={invoiceNumber}
                                                    onClick={handleInvoiceDropdownToggle}
                                                    readOnly
                                                    className={`${inputClass} cursor-pointer`}
                                                    style={gradientBorderStyles}
                                                    placeholder="Select invoice number"
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                                onClick={handleInvoiceDropdownToggle}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                    alt="Dropdown Arrow"
                                                    className={`w-7 h-7 transition-transform ${isInvoiceDropdownOpen ? 'rotate-180' : ''}`}
                                                />
                                            </button>
                                            {isInvoiceDropdownOpen && (
                                                <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                                                    {invoiceOptions.map((option) => (
                                                        <div
                                                            key={option}
                                                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                            onClick={() => handleSelectInvoice(option)} >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="orderNumber" className={labelClass}>Order Number</label>
                                        <input type="text" id="orderNumber" placeholder="" className={inputClass} style={gradientBorderStyles} onChange={(e) => setOrderNumber(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-6">
                                <div className={getInputContainerClass(3)}>
                                    <div>
                                        <label htmlFor="invoiceDate" className={labelClass}>Invoice Date</label>
                                        <input type="text" id="invoiceDate" placeholder="25/11/24" className={inputClass} style={gradientBorderStyles} onChange={(e) => setInvoiceDate(e.target.value)} />
                                    </div>
                                    <div>
                                        <label htmlFor="terms" className={labelClass}>Terms</label>
                                        <div className="relative" ref={termsRef}>
                                            <div>
                                                <input
                                                    type="text"
                                                    value={terms}
                                                    onClick={handleTermsDropdownToggle}
                                                    readOnly
                                                    className={`${inputClass} cursor-pointer`}
                                                    style={gradientBorderStyles}
                                                    placeholder="Select terms" />
                                            </div>
                                            <button
                                                type="button"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                                onClick={handleTermsDropdownToggle}>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                    alt="Dropdown Arrow"
                                                    className={`w-7 h-7 transition-transform ${isTermsDropdownOpen ? 'rotate-180' : ''}`} />
                                            </button>
                                            {isTermsDropdownOpen && (
                                                <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-10">
                                                    {termsOptions.map((option) => (
                                                        <div
                                                            key={option}
                                                            className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                            onClick={() => handleSelectTerms(option)}>
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="dueDate" className={labelClass}>Due Date</label>
                                        <input type="text" id="dueDate" placeholder="25/11/2024" className={inputClass} style={gradientBorderStyles} onChange={(e) => setDueDate(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-8 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)", }} />
                            <div className="mt-4">
                                <label htmlFor="Subject" className={labelClass}>Subject</label>
                                <textarea
                                    id="Subject"
                                    className={`${inputClass} w-[80%] h-22 resize-none`}
                                    style={gradientBorderStyles}
                                    placeholder="Let your customer know what this invoice is for "
                                    onChange={(e) => setSubject(e.target.value)} />
                            </div>
                            <div className="mt-6">
                                <div className="rounded-3xl overflow-hidden bg-zinc-100 shadow-lg">
                                    <div className="flex justify-between bg-sky-950  text-white items-center px-6 py-2">
                                        <h4 className="font-montserrat text-lg text-white">Item Table</h4>
                                        <div className="flex gap-2">
                                            <button className="flex items-center gap-2 py-2 px-4 rounded-3xl bg-transparent  text-[#3483BE]">
                                                <img src={`${process.env.PUBLIC_URL}/images/desktop/lucide_scan-line.svg`}
                                                    alt="Icon"
                                                    className="w-5 h-5" />
                                                <span className="text-white underline decoration-1 underline-offset-2">Scan Item</span>
                                            </button>
                                            <button className="flex items-center gap-2 py-2 px-4 rounded-3xl bg-transparent  text-[#3483BE]">
                                                <img src={`${process.env.PUBLIC_URL}/images/desktop/mage_checklist-note.svg`}
                                                    alt="Icon"
                                                    className="w-5 h-5" />
                                                <span className="text-white underline decoration-1 underline-offset-2">Bulk Actions</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="overflow-x-auto relative">
                                        <table className="min-w-full table-auto bg-zinc-100">
                                            <thead>
                                                <tr className="text-center bg-zinc-300 text-neutral-600">
                                                    <th className="p-2">Item Details</th>
                                                    <th className="p-2">Quantity</th>
                                                    <th className="p-2">Rate</th>
                                                    <th className="p-2">Tax</th>
                                                    <th className="p-2">Amount</th>
                                                    <th className="p-2"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {table.map((data, index) => (
                                                    <tr key={index} className="border-b">
                                                        <td className="p-2">
                                                            <div className="relative dropdown-container" ref={itemRef} style={gradientBorderStyles}>
                                                                <input
                                                                    type="text"
                                                                    value={data.itemDetails}
                                                                    onClick={() => setActiveDropdown({ rowIndex: index, type: 'item' })}
                                                                    className="w-[90%] py-3 px-4 bg-white border-0 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600 transition duration-200"
                                                                    placeholder="Type or click to select an item"
                                                                    readOnly
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                                                    onClick={() => setActiveDropdown({ rowIndex: index, type: 'item' })}
                                                                >
                                                                    <img
                                                                        src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                                        alt="Dropdown Arrow"
                                                                        className={`w-7 h-7 transition-transform ${activeDropdown.rowIndex === index && activeDropdown.type === 'item' ? 'rotate-180' : ''}`}
                                                                    />
                                                                </button>
                                                                {activeDropdown.rowIndex === index && activeDropdown.type === 'item' && (
                                                                    <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-20">
                                                                        {itemOptions.map((option) => (
                                                                            <div
                                                                                key={option}
                                                                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                                                onClick={() => {
                                                                                    setTable(prev => {
                                                                                        const newTable = [...prev];
                                                                                        newTable[index].itemDetails = option;
                                                                                        return newTable;
                                                                                    });
                                                                                    setActiveDropdown({ rowIndex: null, type: null });
                                                                                }}
                                                                            >
                                                                                {option}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <input
                                                                type="number"
                                                                value={data.quantity}
                                                                className="w-full bg-transparent border-0 focus:outline-none text-center"
                                                                placeholder="0.00"
                                                                onChange={(e) => setTable((prev) => {
                                                                    const newTable = [...prev];
                                                                    newTable[index].quantity = parseInt(e.target.value);
                                                                    return newTable;
                                                                })}
                                                            />
                                                        </td>
                                                        <td className="p-2">
                                                            <input
                                                                type="number"
                                                                value={data.rate}
                                                                className="w-full bg-transparent border-0 focus:outline-none text-center"
                                                                placeholder="0.00"
                                                                onChange={(e) => setTable((prev) => {
                                                                    const newTable = [...prev];
                                                                    newTable[index].rate = parseInt(e.target.value);
                                                                    return newTable;
                                                                })}
                                                            />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="relative dropdown-container" ref={taxRef} style={gradientBorderStyles}>
                                                                <input
                                                                    type="text"
                                                                    value={data.tax}
                                                                    onClick={() => setActiveDropdown({ rowIndex: index, type: 'tax' })}
                                                                    className={`${inputClass} !py-2 text-center`}
                                                                    placeholder="Select a Tax"
                                                                    readOnly
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                                                    onClick={() => setActiveDropdown({ rowIndex: index, type: 'tax' })}
                                                                >
                                                                    <img
                                                                        src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                                        alt="Dropdown Arrow"
                                                                        className={`w-7 h-7 transition-transform ${activeDropdown.rowIndex === index && activeDropdown.type === 'tax' ? 'rotate-180' : ''}`}
                                                                    />
                                                                </button>
                                                                {activeDropdown.rowIndex === index && activeDropdown.type === 'tax' && (
                                                                    <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-20">
                                                                        {taxOptions.map((option) => (
                                                                            <div
                                                                                key={option}
                                                                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                                                onClick={() => {
                                                                                    setTable(prev => {
                                                                                        const newTable = [...prev];
                                                                                        newTable[index].tax = option;
                                                                                        return newTable;
                                                                                    });
                                                                                    setActiveDropdown({ rowIndex: null, type: null });
                                                                                }}
                                                                            >
                                                                                {option}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <input
                                                                type="number"
                                                                value={calculateAmount(data.quantity, data.rate, data.tax)}
                                                                className="w-full bg-transparent border-0 focus:outline-none text-center"
                                                                placeholder="0.00"
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <div className="flex justify-center gap-4">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/images/desktop/editicon.svg`}
                                                                    alt="Edit Icon"
                                                                    className="w-5 h-5 cursor-pointer"
                                                                />
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/images/desktop/deleteicon.svg`}
                                                                    className="w-5 h-5 cursor-pointer"
                                                                    alt="Delete Icon"
                                                                    onClick={() => handleDeleteRow(index)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        <div className="px-6">
                                            <hr className="mt-0 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)" }} />
                                        </div>

                                        <div className="flex justify-start px-6 pb-6 gap-4">
                                            <button className="px-4 py-2 text-white font-semibold rounded-full flex items-center gap-2"
                                                style={{ background: 'linear-gradient(180deg, #3483BE 0%, #02385E 100%)', }}
                                                onClick={() => handleAddNewRow()}
                                            >
                                                <span style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '500', lineHeight: '24.38px', }}>
                                                    Add New Row
                                                </span>
                                                <img src={`${process.env.PUBLIC_URL}/images/desktop/staffadd.svg`} alt="Add Staff Icon" className="w-4 h-4 ml-2" />
                                            </button>

                                            <button className="px-4 py-2 text-white font-semibold rounded-full flex items-center gap-2"
                                                style={{ background: 'linear-gradient(180deg, #3483BE 0%, #02385E 100%)', }}  >
                                                <span style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '500', lineHeight: '24.38px', }}>
                                                    Add Items In Bulk
                                                </span>
                                                <img src={`${process.env.PUBLIC_URL}/images/desktop/staffadd.svg`} alt="Add Staff Icon" className="w-4 h-4 ml-2" />
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-8 mb-6 w-full" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)", }} />
                            <div className="flex gap-8 mt-8">
                                <div className="w-1/2">
                                    <div className="rounded-3xl overflow-hidden bg-zinc-100 shadow-lg">
                                        <div className="flex justify-between bg-zinc-300 text-white items-center px-6 py-2">
                                            <h4 className="font-montserrat text-lg text-gray-900">Sub Total</h4>
                                            <div className="flex gap-2">
                                                <div className="flex items-center gap-2 bg-transparent text-[#3483BE]">
                                                    <span className="text-gray-900">0.00</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overflow-x-auto relative p-4">
                                            <div className="flex justify-between items-center mb-2">
                                                <span className="text-gray-700">Discount</span>
                                                <div className="relative w-24">
                                                    <input type="number"
                                                        className="w-full py-2 pl-2 pr-8 bg-white border rounded-lg text-left appearance-none"
                                                        placeholder="0.00" style={gradientBorderStyles} />
                                                    <div className="absolute  inset-y-0 left-1/2 w-px bg-cyan-600" />
                                                    <div className="absolute inset-y-0 right-2 flex items-center">
                                                        <img src={`${process.env.PUBLIC_URL}/images/desktop/basil_invoice-outline.svg`} className="h-4 w-4 " />
                                                    </div>
                                                </div>
                                                <span className="text-right w-24">0.00</span>
                                            </div>
                                            <hr className="my-3" style={{
                                                border: "none", height: "2px",
                                                background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)"
                                            }} />
                                            <div className="flex items-center gap-4 mb-3 w-full">
                                                <div className="flex items-center gap-4">
                                                    <label className="flex items-center cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="taxType"
                                                            value="TDS"
                                                            checked={selectedTaxType === 'TDS'}
                                                            onChange={(e) => setSelectedTaxType(e.target.value)}
                                                            className="mr-2 w-5 h-5 cursor-pointer" />
                                                        <span className="text-gray-700">TDS</span>
                                                    </label>
                                                    <label className="flex items-center cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="taxType"
                                                            value="TCS"
                                                            checked={selectedTaxType === 'TCS'}
                                                            onChange={(e) => setSelectedTaxType(e.target.value)}
                                                            className="mr-2 w-5 h-5 cursor-pointer" />
                                                        <span className="text-gray-700">TCS</span>
                                                    </label>
                                                </div>
                                                <div className="flex flex-1 justify-between items-center">
                                                    <div className="relative flex-1 ml-10" ref={tdsRef}>
                                                        <div className="relative" style={gradientBorderStyles}>
                                                            <input
                                                                type="text"
                                                                value={selectedTdsOption}
                                                                onClick={handleTdsDropdownToggle}
                                                                readOnly
                                                                className=" py-3 pl-4 pr-12 bg-white border-0 rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600 transition duration-200 cursor-pointer"
                                                                placeholder="Select a tax" />
                                                            <button type="button"
                                                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                                                onClick={handleTdsDropdownToggle}>
                                                                <img src={`${process.env.PUBLIC_URL}/images/desktop/light-arrow-drop-down.svg`}
                                                                    alt="Dropdown Arrow"
                                                                    className={`w-7 h-7 transition-transform ${isTdsDropdownOpen ? 'rotate-180' : ''}`} />
                                                            </button>
                                                        </div>
                                                        {isTdsDropdownOpen && (
                                                            <div className="absolute top-full left-0 w-full mt-2 bg-white shadow-lg rounded-xl z-20">
                                                                {tdsOptions.map((option) => (
                                                                    <div
                                                                        key={option}
                                                                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                                                        onClick={() => handleSelectTds(option)}>
                                                                        {option}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <span className="text-right w-24 text-gray-700">-0.00</span>
                                                </div>
                                            </div>
                                            <div className="flex items-center w-full mb-2">
                                                <div className="w-[62.5%] flex gap-4">
                                                    <input type="text"
                                                        className="w-3/5 py-3 px-4 bg-white rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                                                        placeholder="Adjustments"
                                                        style={gradientBorderStyles} />
                                                    <input type="text"
                                                        className="w-2/5 py-3 px-4 bg-white rounded-3xl focus:outline-none focus:ring-2 focus:ring-blue-600"
                                                        placeholder="" style={gradientBorderStyles} />
                                                </div>
                                                <div className="flex items-center flex-1">
                                                    <div className="flex items-center justify-center ml-4">
                                                        <img src={`${process.env.PUBLIC_URL}/images/desktop/question-circle.svg`} alt="Invoice Icon"
                                                            className="w-6 h-6" />
                                                    </div>
                                                    <div className="flex-1 flex justify-end">
                                                        <span className="text-gray-700 w-24 text-right">0.00</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className="my-3" style={{ border: "none", height: "2px", background: "linear-gradient(to right, #FFFFFF 0%, #72AAD2 33%, #5E9DCB 66%, #FFFFFF 100%)" }} />
                                            <div className="flex justify-between items-center">
                                                <span className="font-semibold">Total</span>
                                                <span className="font-semibold">0.00</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-1/2 flex flex-col justify-center">
                                    <div className="h-1/2 flex flex-col">
                                        <h4 className="font-montserrat text-lg mb-4">
                                            Customer Notes <span className="text-gray-500 text-sm">(will be displayed on the invoice)</span>
                                        </h4>
                                        <textarea
                                            className={`${inputClass} flex-grow min-h-[200px] resize-none`}
                                            style={gradientBorderStyles}
                                            placeholder="Thanks for your business."
                                            onChange={(e) => setCustomerNotes(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-10">
                                <div className="overflow-hidden bg-zinc-100 shadow-lg">
                                    <div className="flex justify-between bg-zinc-300 text-white items-center px-6 py-2">
                                        <h4 className="font-montserrat text-lg text-gray-900">Terms and conditions</h4>
                                    </div>

                                    <div className="p-6 flex gap-6">
                                        <div className="w-3/4">
                                            <div className="bg-white rounded-3xl p-6 shadow-sm">
                                                <div className="mb-4">1. Invoice to be settled immediately.</div>
                                                <div >2. Our fees is charged on the basis of value deliveres,time spend and expenses incureed  </div>
                                                <div className="ml-3">having regardto our professional skills and responsibilites.</div>
                                            </div>
                                        </div>

                                        <div className="w-1/4">
                                            <h5 className="font-montserrat text-base font-medium mb-3">
                                                Attach file(s) to invoice
                                            </h5>
                                            <div className=" px-4">
                                                <input
                                                    type="file"
                                                    className={`${inputClass} w-30`}
                                                    style={gradientBorderStyles}
                                                    multiple
                                                />
                                                <p className="text-xs text-gray-500 mt-2">
                                                    Upload limit: 10 files, 10 MB each
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-center h-full">
                        <button 
                        onClick={handleSave} 
                        disabled={isGenerating}
                        className={`text-center p-3 text-white mt-5 mb-5 rounded-3xl font-medium hover:bg-gray-50 ${
                            isGenerating 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-gradient-to-r from-[#3483BE] to-[#02385E]'
                        }`}
                    >
                        {isGenerating ? 'Generating...' : 'Generate'}
                    </button>
                        </div>
                    </div>
                </div>
            </div>
            {showToast && (
                <Toast
                    message={toastMessage}
                    isError={
                        toastMessage.includes('Error') ||
                        toastMessage.includes('Cannot') ||
                        toastMessage.includes('Failed')
                    }
                    show={showToast}
                    onClose={() => setShowToast(false)}
                />
            )}
        </div>
    );
};

export default AccountNewInvoice;